module.exports = __webpack_public_path__ + "static/media/iconLoved.7fc40c11.svg";